/**
 * Descarga en el navegador un fichero recibido en base64
 * @param {string} base64 - Contenido del fichero en base64
 * @param {string} mime - Tipo MIME (ej: "application/pdf")
 * @param {string} nombre - Nombre del fichero descargado, con extensión
 */
export const descargarBase64 = (base64, mime, nombre) => {
    const binario = atob(base64);
    const bytes = Uint8Array.from(binario, (caracter) => caracter.charCodeAt(0));
    const url = URL.createObjectURL(new Blob([bytes], { type: mime }));

    const enlace = document.createElement("a");
    enlace.href = url;
    enlace.download = nombre;
    document.body.appendChild(enlace);
    enlace.click();
    document.body.removeChild(enlace);
    URL.revokeObjectURL(url);
};
